import { render } from "./FeatureDetails.vue?vue&type=template&id=8bcb76a8"
import script from "./FeatureDetails.vue?vue&type=script&lang=js"
export * from "./FeatureDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__